import { RootState } from "../../Store";

export const selectNutrientType = (state: RootState) => state.solution.selectedNutrient;

export const selectAllMulticoteBlends = (state: RootState) => state.solution.multicoteBlendsState.multicoteBlends;
export const selectBlendObject = (state: RootState) => state.solution.selectedBlendObject;

export const selectCalculateSolutionInProgress = (state: RootState) => state.solution.calculateSolutionResultInProgress;

export const selectCalculateSolutionIsSuccess = (state: RootState) => state.solution.calculateSolutionResultIsSuccess;

export const selectReleaseGraphState = (state: RootState) => state.solution.releaseGraphState;
export const selectUserEditAfterGettingResult = (state: RootState) => state.solution.userEditAfterGettingResult;
export const selectTemperatureState = (state: RootState) => state.solution.temperatureState;
export const selectItemId = (state: RootState) => state.solution.itemId;
export const selectSaveFlag = (state: RootState) => state.solution.saveInProgress;
export const selectIsUserSave = (state: RootState) => state.solution.isUserSave;
export const selectItemName = (state: RootState) => state.solution.itemName;
export const selectPlantingDate = (state: RootState) => state.solution.plantingDate;
